<div id="chart">
  <apx-chart
    [series]="chartOptions.series!"
    [chart]="chartOptions.chart!"
    [labels]="chartOptions.labels!"
    [fill]="chartOptions.fill!"
    [legend]="chartOptions.legend!"
    [dataLabels]="chartOptions.dataLabels!"
    [tooltip]="chartOptions.tooltip!"
  ></apx-chart>
</div>
